module.exports = __webpack_public_path__ + "static/media/mask2.5c68a9a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mask2.png
// module id = 200
// module chunks = 0